/**
 *  アプリケーション共通で使用する定数
 */
const APP_CONSTANTS = {
  // APIの定期更新間隔
  REFETCH_INTERVAL_TIME: 10000,
}

export type QueryOperator = '=' | '<=' | '>=' | '!=';

export const BREAK_POINT_CONSTANTS = {
  SM: 576,
  MD: 768,
  LG: 1024,
  XSS: 352,
}

export const SPACE_CONSTANTS = {
  MEMBER: {
    DISPLAY_USER_ID_MAX_LENGTH: 12,
  }
}

export default APP_CONSTANTS;